export const PROFILE = 'user-profile';
export const RESULT = 'questionnaire-status';
export const REFRESH_TOKEN = 'ast-refresh';
export default { PROFILE, RESULT };
